import axios from 'axios';
import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import DefaultLoader from '../../../components/loader/DefaultLoader';
import BatterTable from '../../../components/table/BatterTable';
import { flatObject } from '../../../utils/flat';
import {useCookies} from 'react-cookie';
import TableWrapper from '../../../components/table/TableWrapper';
import dateSetting from '../../../utils/dateSetting';
import Form from 'react-bootstrap/Form';
import BatterTableWrapper from '../../../components/table/BatterTableWrapper';
import { useTranslation } from 'react-i18next';

function SituationBatterRecord({profile}) {
    const [cookies] = useCookies(['hiball_token']);
    let [loading, setLoading] = useState(false);
    let [situationRecord, setSituationRecord] = useState({});

    let dateObj = dateSetting();
    let [season, setSeason] = useState(dateObj['selectboxSeason']);
    let todaySeason = (new Date()).getFullYear();
    const { t } = useTranslation();

    useEffect(() => {
        let {playerId} = profile;

        let situation1 = axios({
            url : `${process.env.REACT_APP_API_URL}`,
            params: {
                recordType: 'digestBattingRecord', recordName: 'selectSituationRecord',
                batterIds: playerId,
                seasons: season,
                gameTypeCode: 4201,
                authToken:JSON.stringify(cookies['hiball_token'])
            }
        });

        let situation2 = axios({
            url : `${process.env.REACT_APP_API_URL}`,
            params: {
                recordType: 'digestBattingRecord', recordName: 'selectPitchSituationRecord',
                batterIds: playerId,
                seasons: season,
                gameTypeCode: 4201,
                authToken:JSON.stringify(cookies['hiball_token'])
            }
        });

        // let situation3 = axios({
        //     url: `${process.env.REACT_APP_API_URL}`,
        //     params: {
        //         recordType: 'digestBattingRecord', recordName: 'selectPitchTableRecord',
        //         batterIds: playerId,
        //         seasons: season,
        //         gameTypeCode: 4201,
        //         authToken:JSON.stringify(cookies['hiball_token'])
        //     }
        // })

        Promise.all([
            situation1, situation2, 
            // situation3
        ]).then((result) => {
            

            let newArr = _.map([
                ...result[0]['data']['result'], 
                ...result[1]['data']['result'],
                // ...ballCodeArr
            ], (item) => {
                return flatObject(item);
            });

            let groupingData = _.groupBy(newArr, (item) => {
                return item['groupingType'];
            });

            setSituationRecord(groupingData);
            setLoading(true);
        });
    }, [season]);

    function seasonHandler(event) {
        let value = event.target.value;
        setLoading(false);
        setSeason(value);
    }

    return (
        <>
        <div style={{position:'absolute', top: '-40px', right: '10px'}}>
            <Form.Group onChange={seasonHandler} style={{display:'inline-block', height: '29px'}}>
                <Form.Select size="sm" defaultValue={dateObj['selectboxSeason']}>
                    <option value={todaySeason-2}>{todaySeason-2}</option>
                    <option value={todaySeason-1}>{todaySeason-1}</option>
                    <option value={todaySeason}>{todaySeason}</option>
                </Form.Select>
            </Form.Group>
        </div>
        {
            !loading ?
            <div style={{height: '1000px'}}><DefaultLoader /></div> :
            <>
            <TableWrapper title={t('platoonSplits')+'-'+season}>
                <BatterTable data={situationRecord['pitcherType']}column={'pitcherType'}/>
            </TableWrapper>
            <BatterTableWrapper title={t('pitchType')+'-'+season} column={'ballCode'} profile={profile} season={season}/>
            <BatterTableWrapper title={t('pitchCount')+'-'+season} column={'count'} profile={profile} season={season}/>
            <BatterTableWrapper title={t('basesOccupied')+'-'+season} column={'runnerType'} profile={profile} season={season}/>
            {/* <TableWrapper title={'구종-'+season}>
                <BatterTable data={situationRecord['ballCode']} column={'count'}/>
            </TableWrapper>
            <TableWrapper title={'카운트-'+season}>
                <BatterTable data={situationRecord['count']} column={'count'}/>
            </TableWrapper>
            <TableWrapper title={'주자 상황-'+season}>
                <BatterTable data={situationRecord['runnerType']} column={'runnerType'}/>
            </TableWrapper> */}
            <TableWrapper title={t('homeoraway')+'-'+season}>
                <BatterTable data={situationRecord['homeOrAway']} column={'homeOrAway'}/>
            </TableWrapper>
            <TableWrapper title={t('opponent')+'-'+season}>
                <BatterTable data={situationRecord['oppTeam']} column={'oppTeam'}/>
            </TableWrapper>
            <TableWrapper title={t('battingOrderPositions')+'-'+season}>
                <BatterTable data={situationRecord['battingOrder']} column={'battingOrder'}/>
            </TableWrapper>
            <TableWrapper title={t('byMonth')+'-'+season}>
                <BatterTable data={situationRecord['month']} column={'month'}/>
            </TableWrapper>
            </>
        }
        </>
    )
}

export default SituationBatterRecord;